import {IResponseDto} from "./interfaces-perfil";

export interface AcessoSistemaModel {
  codSistema?: number;
  codAcesso?: string;
  codPerfil?: number;
  dscPrefil?: string;
}

export interface UsuarioSsoModel {
  codLogin?: string;
  dscLogin?: string;
  dscNome?: string;
  dscEmail?: string;
  dscIdentificacao?: string;
  datNascimento?: Date;
  numRg?: string;
  dscExpedicaoRg?: string;
  datExpedicaoRg?: Date;
  numDddFone?: string;
  numFone?: string;
  DscEmail?: string;
  codAcesso?: string;
  codPerfil?: string;
  codAppPerfil?: string;
  indAtivo?: string;
  cdEmpresa?: string;
  tpEmpresa?: string;
  sistemas?: Array<AcessoSistemaModel>;


}
export interface IAtivarDesativarUsuario {
  codLogin: string;
  codEmpresa: number;
  ativar: boolean;
  codPerfil: number;
}


export interface IPermissaoArmazenamentoLocal {
  codigoPermissao: number;
  dscPermissao?: string;
  codigoMenu: number;
  dscIcon?: string;
  isHomePage: boolean;
  isAtalho: boolean;
  codigoOrdemAtalho: number;
}


export interface IUsuarioArmazenamentoLocal {
  guid: string;
  codigoAcesso: number;
  codigoEntidade: number;
  codigoUsuario: number;
  nome: string;
  nomeFantasia: string;
  login: string;
  tipo: number;
  caminhoneiro: boolean;
  tipoCaminhoneiro?: any;
  uuid?: any;
  uFs?: any;
  modoOperacao?: any;
  codRodocred: number;
  menu?: any;
  appAbast: boolean;
  combustivelPadrao: number;
  textos?: any;
  celular: string;
  firebaseTokenUsuario?: any;
  entidades?: any;
  redes?: any;
  appDestino?: any;
  bancoAtual?: any;
  aparencia: string;
  email: string;
  loginDbtrans?: any;
  perfis?: any;
  permissoes: Array<IPermissaoArmazenamentoLocal> ;

}






